import { render, staticRenderFns } from "./programPlace.vue?vue&type=template&id=4bdedafe&scoped=true&"
import script from "./programPlace.vue?vue&type=script&lang=js&"
export * from "./programPlace.vue?vue&type=script&lang=js&"
import style0 from "./programPlace.vue?vue&type=style&index=0&id=4bdedafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdedafe",
  null
  
)

export default component.exports